import React, { useState } from 'react';
import Swal from 'sweetalert2';
import NagadIcon from '../../src/Assets/icon/NagadIcon.svg';
import BkashIcon from '../../src/Assets/icon/BkashIcon.svg';
import RocketIcon from '../../src/Assets/icon/RocketIcon.svg';
import apiClient from '../Api/apiClient';
const WithdrawModal = ({ isOpen, onClose, tenReqId }) => {
  const [phone, setPhone] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('bkash');

  const handleSubmit = async e => {
    e.preventDefault();

    // Prepare the data for the API request
    const requestData = {
      ten_req_id: tenReqId, 
      payment_type: selectedProvider,
      account_number: phone,
    };

    // console.log('Sending data:', requestData);

    try {
      // Send the PATCH request with Axios
      const response = await apiClient.patch(
        '/affiliator/tender-request/withdraw-request',
        requestData
      );

      // console.log('Withdraw response:', response.data);

      const successMessage = response.data.message;

      Swal.fire({
        title: 'Success!',
        text: successMessage,
        confirmButtonText: 'Okay',
        icon:'success',
        customClass: {
          popup: 'w-80 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });
      setPhone('');
      setSelectedProvider('bkash'); // Reset to default provider
      onClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Something went wrong!';

      Swal.fire({
        title: 'Error!',
        text: errorMessage,
        confirmButtonText: 'Okay',
        icon:'error',
        customClass: {
          popup: 'w-80 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });

      console.error('Error:', error);
    }
  };

  // Ensure modal doesn't render if `isOpen` is false
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white border border-gray-300 rounded-lg w-11/12 max-w-md p-4">
        <h2 className="text-lg font-semibold mb-4">Withdraw Balance</h2>

        <form onSubmit={handleSubmit}>
          <div className="flex justify-center md:gap-4 gap-3 mb-2">
            <div
              onClick={() => setSelectedProvider('bkash')}
              className={`flex flex-col items-center cursor-pointer ${
                selectedProvider === 'bkash'
                  ? 'bg-DefaultColor bg-opacity-15 text-white px-2 py-1 rounded-md'
                  : 'bg-white'
              }`}
            >
              <img src={BkashIcon} alt="bKash" className="w-14 h-8" />
            </div>
            <div
              onClick={() => setSelectedProvider('nagad')}
              className={`flex flex-col items-center cursor-pointer ${
                selectedProvider === 'nagad'
                  ? 'bg-DefaultColor bg-opacity-15 text-white px-2 py-1 rounded-md'
                  : 'bg-white'
              }`}
            >
              <img src={NagadIcon} alt="Nagad" className="w-14 h-8" />
            </div>
            <div
              onClick={() => setSelectedProvider('rocket')}
              className={`flex flex-col items-center cursor-pointer ${
                selectedProvider === 'rocket'
                  ? 'bg-DefaultColor bg-opacity-15 text-white px-2 py-1 rounded-md'
                  : 'bg-white'
              }`}
            >
              <img src={RocketIcon} alt="Rocket" className="w-14 h-8" />
            </div>
          </div>

          <div className="mb-4 space-y-2">
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700"
            >
              Phone Number
              <span className="text-red-500">*</span>
            </label>
            <input
              id="phone"
              type="text"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              required
              className="mt-1 p-2 border border-gray-400 rounded w-full"
              placeholder="Enter your number for receive amount"
              onInput={e => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Only keep numbers
              }}
            />
          </div>

          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-DefaultColor text-white rounded hover:bg-DefaultHoverColor"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WithdrawModal;